import React from "react";
import Modal from "react-bootstrap/Modal";

import "./TemplateModal.scss";

const templateModal = (props) => {
  return (
    <Modal
      className="template-modal"
      size="sm"
      centered
      show={props.showModal}
      onHide={props.handleClose}
    >
      <div role="document" className="modal-sm">
        <div className="modal-header  border-0 is-size-h4 bold">
          {props.status === "Active" ? "Deactivate" : "Activate"}
        </div>
        <div className="modal-body">
          {props.status === "Active" ? (
            <div className="is-size-body-1 d-flex">
              Are you sure you want to deactivate
              <span className="restricted-title px-1">
                <strong> {props.documentType} </strong>
              </span>
              ?
            </div>
          ) : (
            <div className="is-size-body-1 d-flex">
              Are you sure you want to activate
              <p className="restricted-title px-1">
                <strong> {props.documentType} </strong>
              </p>
              ?
            </div>
          )}
        </div>
        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn-secondary"
            onClick={(event) => {
              props.statusHandler(event, props.documentId);
            }}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={props.handleClose}
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default templateModal;
